import InfoPopup from "../CommonComponents/InfoPopup/InfoPopup";
import BubbleSvgButton from "../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import Profile from "../../../assets/images/Profile.svg";
import { Card } from "react-bootstrap";
import VisaVerifiedGrey from "../../../assets/images/verifyTrades/VisaVerifiedGrey.svg";
import threeDSecureIcon from "../../../assets/images/verifyTrades/3dSecureIcon.svg";
import MasterCardSecureCod from "../../../assets/images/verifyTrades/MasterCardSecureCod.svg";
import stripeIcon from "../../../assets/images/verifyTrades/stripeIcon.svg";
import "./SubscriptionBillingHistory.css";
import { useState, useEffect } from "react";
import checkGreen from "../../../assets/images/check-green.svg";
import { useSelector } from "react-redux";
import { getMemberCommunityDisplayName } from "../../../helpers/memberCommunityDisplay";

const SubscriptionPaymentPlan = () => {
  const [activeButton, setActiveButton] = useState("Monthly");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const user = useSelector((state) => state?.user?.user);

  // Single useEffect to handle all subscription data transformation
  useEffect(() => {
    const subscriptionData =
      user?.memberCommunities?.[0]?.community?.subscription || [];

    // Filter to show only active subscriptions
    const activeSubscriptions = subscriptionData.filter(
      (plan) => plan.isActive === true
    );

    if (activeSubscriptions?.length) {
      const transformedPlans = activeSubscriptions.map((plan, index) => ({
        ...plan,
        price:
          activeButton === "Monthly"
            ? `$${plan.monthlyfee} / month`
            : `$${plan.yearlyfee} / year`,
        max: `$${plan.tradingCapital}`,
        description: `${plan.name} - Trade with maximum capital`,
        active: index === 0,
        subscribed: false,
      }));

      setPlans(transformedPlans);

      if (!selectedPlan && transformedPlans.length > 0) {
        setSelectedPlan(transformedPlans[0]);
      }
    }
  }, [activeButton, user]);

  return (
    <>
      <div className="SubscriptionPaymentPlanBox">
        <div className="communityProfileSelection d-flex justify-content-center align-items-center">
          <div className="img-box">
            <img
              src={user?.memberCommunities?.[0]?.community?.logo || Profile}
              alt=""
            />
          </div>
          <p className="communityName">
            {getMemberCommunityDisplayName(user, { fallback: "Community" })}
          </p>
        </div>
        <div className="title">
          Choose your plan
          <InfoPopup
            contentItems={[
              { text: "Subscription Tier", type: "heading" },
              {
                text: "The Maximum Trading Capital (MTC) is the capital used from your connected trading account. Usually 1-5% of MTC is used to trade with per trade. Upgrade if you want to increase your MTC.",
                type: "paragraph",
              },
            ]}
          />
        </div>
        <div className="switchSide p-0">
          <div className="switchBase">
            <button
              className={`${activeButton === "Monthly" ? "active" : ""}`}
              onClick={() => setActiveButton("Monthly")}
            >
              Monthly
            </button>
            <button
              className={`${activeButton === "Yearly" ? "active" : ""}`}
              onClick={() => setActiveButton("Yearly")}
            >
              Yearly
            </button>
          </div>
        </div>

        <div className="row justify-content-start">
          {/* Monthly price input */}
          {plans.map((plan, index) => (
            <div
              className="col-lg-4 col-md-6 col-12 px-sm-3 px-0"
              key={plan._id || index}
            >
              <Card
                className={`subcriptionVerifyTradeCard ${
                  selectedPlan?._id === plan._id ? "active" : ""
                } ${plan.subscribed && "subscribedPlan"}`}
                onClick={() => !plan.subscribed && setSelectedPlan(plan)}
                style={{ cursor: plan.subscribed ? "default" : "pointer" }}
              >
                {plan.subscribed && (
                  <div className="subscribedTextWrap">
                    <p>Subscribed</p>
                  </div>
                )}
                {!plan.subscribed && (
                  <div className="radioCheck">
                    <div
                      className={`circle_radio ${
                        selectedPlan?._id === plan._id ? "d-none" : ""
                      }`}
                    ></div>
                    <img
                      src={checkGreen}
                      alt="Green Check"
                      className={selectedPlan?._id === plan._id ? "" : "d-none"}
                    />
                  </div>
                )}

                <div>
                  <h6
                    className="pricingText"
                    style={{
                      color: `${plan.subscribed ? "#ffffff" : "#000000"}`,
                    }}
                  >
                    {plan.price}
                  </h6>
                  <p
                    className="maxValue"
                    style={{
                      color: `${plan.subscribed ? "#ffffff" : "#000000"}`,
                    }}
                  >
                    Trade with maximum: {plan.max}
                  </p>
                  <p
                    className="DescrpText"
                    style={{
                      color: `${plan.subscribed ? "#ffffff" : "#000000"}`,
                    }}
                  >
                    {plan.description}
                  </p>
                </div>
              </Card>
            </div>
          ))}
        </div>
        <p className="inputBottomText d-block d-md-none text-center">
          7d Free Trial. Cancel or upgrade subscription anytime. Auto-renews{" "}
          {activeButton.toLowerCase()}. Next billing date: 03/10/2025
        </p>
        <div className="d-flex justify-content-md-end justify-content-center">
          <div className="paymentButton">
            <BubbleSvgButton
              text={
                selectedPlan
                  ? `Pay $${
                      activeButton === "Monthly"
                        ? selectedPlan.monthlyfee
                        : selectedPlan.yearlyfee
                    }/${activeButton.toLowerCase()}`
                  : "Select a plan"
              }
              type="button"
              variant="green"
              containerStyling={{
                justifyContent: "center",
              }}
              disabled={!selectedPlan}
            />
          </div>
        </div>

        <div className="d-flex justify-content-md-between justify-content-center align-items-center gap-20 flex-sm-row flex-column-reverse text-sm-start text-center">
          <div className="paymentMethods">
            <p>Safe and Secure Payments Checkout</p>
            <div className="verifiedPaymentMethodsPartners">
              <img src={threeDSecureIcon} alt="Payment Methods" />
              <img src={MasterCardSecureCod} alt="Payment Methods" />
              <img src={VisaVerifiedGrey} alt="Payment Methods" />
              <img src={stripeIcon} alt="Payment Methods" />
            </div>
          </div>
          <p className="inputBottomText d-md-block d-none">
            7d Free Trial. Cancel or upgrade subscription anytime. Auto-renews{" "}
            {activeButton.toLowerCase()}. Next billing date: 03/10/2025
          </p>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPaymentPlan;
